export const BASE_URL_DEV = "https://api.smart-connect.cloud/POS";
export const BASE_URL_PROD = "https://api.smart-connect.cloud/POS";
export const POS_VENDOR_NAME = "Tower Systems";
export const TRANSACTION_ENDPOINT = "/Transaction";
export const PAIRING_ENDPOINT = "/Pairing/[pairingId]";
